<script lang="ts">
    export let position: 'relative' | 'fixed' = 'fixed'

    export let company

    function getLogo() {
        if (company?.logo) return company.logo
        return '/img/logo_black.png'
    }
</script>

<div class="header_print" style="position:{position};">
    <div class="company">{company?.companyName || ''}</div>
    <div class="spacer" />
    <div class="logo"><img src={getLogo()} alt="" /></div>
</div>

<style>
    .header_print {
        height: 60px;
        top: 0px;
        display: flex;
        align-items: center;
        padding: 0px 6px 6px 6px;
        width: 100%;
        background-color: white;
        border-radius: 8px 8px 0px 0px;
    }
    .header_print .company {
        font-size: 22px;
    }
    .header_print .logo {
    }
    .header_print img {
        max-height: 48px;
    }

    @media (max-width: 900px) {
        .header_print img {
            max-height: 38px;
        }

        .header_print {
            flex-direction: column-reverse;
            height: 80px;
        }
    }

    @media print {
        .header_print {
            border-bottom: 1px solid #333;
            flex-direction: unset;
            height: 60px;
        }
    }
</style>
